import "media-chrome/react";
import { MediaTheme } from "media-chrome/react/media-theme";
import "media-chrome/react/menu";
import { themeTemplateHTML } from "./template";

interface PlayerThemeProps {
  children: React.ReactNode;
  downloadable?: boolean;
  downloadUrl?: string;
  playbackRates?: string;
}

export const PlayerTheme = ({
  playbackRates = "0.5 0.75 1 1.25 1.5 1.75 2",
  downloadable = false,
  downloadUrl,
  children,
}: PlayerThemeProps) => (
  <>
    <template
      id="media-theme-default"
      dangerouslySetInnerHTML={{ __html: themeTemplateHTML }}
    />
    <MediaTheme
      template="media-theme-default"
      style={{ width: "100%", height: "100%", aspectRatio: "16/9" }}
      rates={playbackRates}
      downloadable={downloadable}
      downloadUrl={downloadUrl}
    >
      {children}
    </MediaTheme>
  </>
);
